import { merge } from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  isFetching: false
};

export default function reviews (state = initialState, action) {
  switch (action.type) {
  case types.REVIEW_FETCH_REQUEST:
    return merge({}, state, {
      isFetching: true
    });

  case types.REVIEW_FETCH_SUCCESS:
    return merge({}, state, {
      isFetching: false,
      isFetched: true,
      [action.payload._id]: action.payload
    });

  case types.REVIEW_FETCH_FAILURE:
    return merge({}, state, {
      isFetching: false,
      isFetched: true
    });

  case types.REVIEW_UPDATE_REQUEST:
    return merge({}, state, {
      isPatching: true
    });

  case types.REVIEW_UPDATE_SUCCESS:
    return merge({}, state, {
      isPatching: false,
      ...action.payload
    });

  case types.REVIEW_UPDATE_FAILURE:
    return merge({}, state, {
      isPatching: false
    });

  default:
    return state;
  }
}
